import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ExpenseReportServices } from './expense-report.service';
import { firstValueFrom, Subscription } from 'rxjs';
import moment from 'moment';
import { ToWords } from 'to-words';
import CurrencyList from 'currency-list'
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

declare var customToastr: any;
@Component({
  selector: 'app-expense-report',
  templateUrl: './expense-report.component.html',
  styleUrls: ['./../../assets/css/theme-default/bootstrap.css',
    './../../assets/css/theme-default/materialadmin.css',
    /*'./../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
    './../../assets/css/theme-default/font-awesome.min.css',
    './../../assets/css/theme-default/material-design-iconic-font.min.css',
    './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
    './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
    './../../css/datepicker.css',
    './expense-report.component.css'],
  encapsulation: ViewEncapsulation.None,
})

export class ExpenseReportComponent implements OnInit {
  currencyType = localStorage.getItem('currency')
  currencyName = CurrencyList.get(this.currencyType)
  toWords = new ToWords({
    converterOptions: {
      currency: true,
      currencyOptions: {
        name: this.currencyName.name,
        plural: this.currencyName.name_plural,
        symbol: this.currencyName.symbol,
        fractionalUnit: {
          name: this.currencyName.name,
          plural: this.currencyName.name_plural,
          symbol: this.currencyName.symbol,
        },
      }
    }
  });
  academicYears = [];
  selectedAcademicYear: any = [];
  academicId: string = "";
  payeeType = [];
  payeeName = [];
  paymentMethods = [];
  selectedPayeeName = [];
  selectedPayeeType = [];
  selectedPaymentMethods = [];
  statData = [];
  startDate: any;
  endDate: any;
  startingPageNumber: any = 1;
  maxPageNumber: any;
  totalRecords: any;
  selectedAcademicYearStartDate: any;
  selectedAcademicYearEndDate: any;
  selectedLimit: number = 10;
  sendingReport = false;
  fetchingTable = true;
  schoolCurrencySymbol
  fetchingStatData = true;
  isFilterApplied = false;
  isFilterOpen: boolean = false;
  expenseColumnData = []
  expenseRowData = []
  expenseColumnIndex: string = "";
  isCurrentAcademic = true;
  string: any;
  appliedPayeeType: any = "All";
  appliedPayeeName: any = "All";
  appliedPaymentMethod: any = "All";
  appliedPaymentDate: any = [];
  emailIds = "";
  openExportPopUp: boolean = false;
  customSelectionLabelForPaymentMethodName = "All"
  customSelectionLabelForPayeeName = "All"
  customSelectionLabel = "All"
  langChangeSub: Subscription;

  constructor(private expenseService: ExpenseReportServices, private translate: TranslateService) {
    const getSchoolInfo = localStorage.getItem('schoolAllInfo');
    const parsedInfo = getSchoolInfo && JSON.parse(getSchoolInfo);
    this.schoolCurrencySymbol = parsedInfo.schoolCurrencySymbol;
    this.startDate = parsedInfo.currentAcademicStartDate;
    this.endDate = parsedInfo.currentAcademicEndDate;
    const currentAcademicId = parsedInfo.currentAcademicId;
    this.academicId = currentAcademicId;
    this.getAcademicYears()
    this.getPayeeType(currentAcademicId);
    this.getPayeeName(currentAcademicId);
    this.getPaymentMethod(currentAcademicId)
    this.getStatDataForExpense(currentAcademicId);
    this.getReportData(currentAcademicId, this.startingPageNumber);
  }
  // function for open filter
  expandView() {
    this.isFilterOpen = !this.isFilterOpen;
  }

  // for open table column option
  expandExpenseColumnOption(index) {
    this.expenseColumnIndex = this.expenseColumnIndex === index ? null : index;
  }

  // function for off the column selection on outside click
  collapseExpenseColumnOption() {
    event.stopPropagation();
    this.expenseColumnIndex = "";
  }

  // function fo change table data according to slug selection
  async updateExpenseTableColumn(currentSlug, newSlug) {
    const currentSlugDataIndex = this.expenseColumnData.findIndex((item) => {
      const data = item as any;
      return data.slug === currentSlug;
    });
    const newSlugDataIndex = this.expenseColumnData.findIndex((item) => {
      const data = item as any;
      return data.slug === newSlug;
    });
    if (currentSlugDataIndex !== -1 && newSlugDataIndex !== -1) {
      const slugCurrentData = this.expenseColumnData[currentSlugDataIndex];
      const slugNewData = this.expenseColumnData[newSlugDataIndex];
      const currentInfo = slugCurrentData as any;
      const newInfo = slugNewData as any;
      currentInfo.isDefault = 0;
      newInfo.isDefault = 1;
      if (this.expenseColumnData.length > 0) {
        this.expenseColumnData[currentSlugDataIndex] = newInfo;
        this.expenseColumnData[newSlugDataIndex] = currentInfo;
      }
    }
  }

  // function to get academic years data
  async getAcademicYears() {
    try {
      const response: any = await firstValueFrom(this.expenseService.getAcademicYears());
      if (response.status && response.body) {
        this.academicYears = response.body.academicListData;
        this.selectedAcademicYear = this.academicYears.find(item => item.isCurrentAcademic);
      }
      else {
        this.academicYears = [];
      }
    }
    catch (error) {
      this.academicYears = [];
    }
  }

  // function for selected by default all
  markAllAsSelected(array: any[]): any[] {
    return array.map(item => ({
      ...item,
      isSelected: true
    }));
  }

  // function for lang change 
  ngOnInit(): void {
    this.getTranslation();
    this.langChangeSub = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.getTranslation();
    });
  }

  // function for fetch value from translation
  getTranslation(): void {
    this.translate.get('expenseReport').subscribe((res: any) => {
      this.string = res;
    });
  }

  // function for get payee type
  async getPayeeType(academicId) {
    try {
      const body = {
        lang: "en",
        academicId: academicId
      }
      const response: any = await firstValueFrom(this.expenseService.getPayeeType(body));
      if (response.status && response.body) {
        this.payeeType = this.markAllAsSelected(response.body.payeeTypeList);
        this.selectedPayeeType = this.payeeType.filter(item => item.isSelected);
      }
    }
    catch (error) {
      this.payeeType = [];
    }
  }

  // function get id for payee type
  formatPayeeType(payeeType) {
    let arr = [];
    if (payeeType.length > 0) {
      for (let key of payeeType) {
        arr.push(key.payeeType);
      }
      return arr;
    }
    return "All";
  }

  // function get id for payee name
  formatPayeeName(payeeName) {
    let arr = [];
    if (payeeName.length > 0) {
      for (let key of payeeName) {
        arr.push(key.payeeId);
      }
      return arr;
    }
    return "All";
  }

  // function get id for payment methods type
  formatPaymentMethod(paymentMethod) {
    let arr = [];
    if (paymentMethod.length > 0) {
      for (let key of paymentMethod) {
        arr.push(key.paymentMethodId);
      }
      return arr;
    }
    return "All";
  }

  // function for get payee name
  async getPayeeName(id) {
    try {
      const body = {
        lang: "en",
        academicId: id,
        payeeType: this.appliedPayeeType !== "All" ? ((this.payeeType.length === this.appliedPayeeType.length) ? "All" : this.formatPayeeType(this.selectedPayeeType)) : "All",
      }
      const response: any = await firstValueFrom(this.expenseService.getPayeeName(body))
      if (response.status && response.body) {
        this.payeeName = this.markAllAsSelected(response.body.payeeNameList);
        this.selectedPayeeName = this.payeeName.filter(item => item.isSelected);
      }
    }
    catch (error) {
      this.payeeName = this.markAllAsSelected([]);
    }
  }

  // function for get payment methods
  async getPaymentMethod(id) {
    try {
      const body = {
        lang: "en",
        academicId: id
      }
      const response: any = await firstValueFrom(this.expenseService.getPaymentMethod(body));
      if (response.status && response.body) {
        this.paymentMethods = this.markAllAsSelected(response.body.paymentMethodList);
        this.selectedPaymentMethods = this.paymentMethods.filter(item => item.isSelected);
      }
    }
    catch (error) {
      this.paymentMethods = [];
    }
  }


  // function for calendar 
  selected: { startDate: moment.Moment; endDate: moment.Moment };
  selectedStartDate: string;
  selectedEndDate: string;
  todayDate = moment().format('YYYY-MM-DD');
  academicStartDate = moment().subtract(1, 'year').format('YYYY-MM-DD'); // example
  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
  };
  locale: any = {
    format: 'YYYY-MM-DD',
    displayFormat: 'YYYY-MM-DD',
  };
  appliedStartDate: any;
  appliedEndDate: any;
  datesUpdated(event: any): void {
    this.selectedStartDate = event.startDate.format('YYYY-MM-DD');
    this.selectedEndDate = event.endDate.format('YYYY-MM-DD');
    this.appliedStartDate = event.startDate.format('YYYY-MM-DD');
    this.appliedEndDate = event.endDate.format('YYYY-MM-DD');
  }
  rangeClicked(range): void {
    this.appliedStartDate = moment(range.dates[0]).format('YYYY-MM-DD');
    this.appliedEndDate = moment(range.dates[1]).format('YYYY-MM-DD')
  }

  // function for get stat data
  async getStatDataForExpense(id) {
    try {
      this.fetchingStatData = true;
      const body = {
        lang: "en",
        academicId: id,
        payeeNameId:
          this.appliedPayeeName !== "All"
            ? (
              this.appliedPayeeName.length === 0
                ? []
                : (this.payeeName.length === this.appliedPayeeName.length
                  ? "All"
                  : this.formatPayeeName(this.appliedPayeeName)
                )
            )
            : "All",
        paymentMethodId:
          this.appliedPaymentMethod !== "All"
            ? (
              this.appliedPaymentMethod.length === 0
                ? []
                : (this.paymentMethods.length === this.appliedPaymentMethod.length
                  ? "All"
                  : this.formatPaymentMethod(this.appliedPaymentMethod)
                )
            )
            : "All",
        startDate: this.startDate,
        endDate: this.endDate
      }
      const response: any = await firstValueFrom(this.expenseService.getStatData(body))
      if (response.status && response.body) {
        this.statData = response?.body?.expenseReportStats?.statInfo;
        this.totalRecords = response?.body?.expenseReportStats?.availableResults;
      }
      else {
        this.statData = [];
      }
      this.fetchingStatData = false;
    }
    catch (error) {
      this.statData = [];
      this.fetchingStatData = true;
    }
  }

  // function get report table  data
  async getReportData(id, pageNumber) {
    try {
      this.fetchingTable = true;
      const body = {
        lang: "en",
        academicId: id,
        payeeNameId:
          this.appliedPayeeName !== "All"
            ? (
              this.appliedPayeeName.length === 0
                ? []
                : (this.payeeName.length === this.appliedPayeeName.length
                  ? "All"
                  : this.formatPayeeName(this.appliedPayeeName)
                )
            )
            : "All", paymentMethodId:
          this.appliedPaymentMethod !== "All"
            ? (
              this.appliedPaymentMethod.length === 0
                ? []
                : (this.paymentMethods.length === this.appliedPaymentMethod.length
                  ? "All"
                  : this.formatPaymentMethod(this.appliedPaymentMethod)
                )
            )
            : "All",
        startDate: this.startDate,
        endDate: this.endDate,
        pageNumber: pageNumber,
        pageLimit: this.selectedLimit
      }
      const response: any = await firstValueFrom(this.expenseService.getReportData(body))
      if (response.status && response.body) {
        this.maxPageNumber = response.body.maxPageNumber;
        if (this.expenseColumnData.length === 0) {
          this.expenseColumnData = response.body.reportColumnList;
        }
        this.expenseRowData = response.body.reportExpenseData;
      }
      this.fetchingTable = false;

    }
    catch (error) {
      this.fetchingTable = false;
    }
  }

  // function for change academic year
  changeAcademicYear() {
    const currentAcademicId = this.selectedAcademicYear.pkAcademicId;
    this.appliedPayeeName = "All"
    this.appliedPayeeType = "All"
    this.appliedPaymentMethod = "All"
    this.academicId = currentAcademicId;
    this.startDate = this.selectedAcademicYear.academicStartDate;
    this.endDate = this.selectedAcademicYear.academicEndDate;
    this.getPayeeType(currentAcademicId);
    this.getPayeeName(currentAcademicId);
    this.getPaymentMethod(currentAcademicId)
    this.getStatDataForExpense(currentAcademicId);
    this.getReportData(currentAcademicId, 1);
    this.updatePayeeTypeLabel();
    this.updatePayeeNameLabel();
    this.updateSelectionPayeeNameLabel()
  }

  // function for apply filter
  applyFilter() {
    this.isFilterApplied = true;
    this.appliedPayeeType = this.isAllSelected(this.selectedPayeeType)
      ? this.selectedPayeeType
      : "All";
    this.startDate = this.appliedStartDate ? this.appliedStartDate : (this.selectedStartDate ? this.selectedStartDate : this.selectedAcademicYear.academicStartDate);
    this.endDate = this.appliedEndDate ? this.appliedEndDate : (this.selectedStartDate ? this.selectedStartDate : this.selectedAcademicYear.academicEndDate);
    console.log("se",this.startDate,this.selectedStartDate,this.appliedStartDate);
    

    this.appliedPayeeName = this.isAllSelected(this.selectedPayeeName)
      ? this.selectedPayeeName
      : "All";

    this.appliedPaymentMethod = this.isAllSelected(this.selectedPaymentMethods)
      ? this.selectedPaymentMethods
      : "All";
    this.getStatDataForExpense(this.academicId);
    this.getReportData(this.academicId, 1);
  }

  // function for after reset filter apply
  applyResetFilter() {
    this.isFilterApplied = true;
    this.appliedPayeeType = this.isAllSelected(this.selectedPayeeType)
      ? this.selectedPayeeType
      : "All";
    this.startDate = this.selectedAcademicYear.academicStartDate;
    this.endDate = this.selectedAcademicYear.academicEndDate
    this.appliedPayeeName = this.isAllSelected(this.selectedPayeeName)
      ? this.selectedPayeeName
      : "All";
    this.appliedPaymentMethod = this.isAllSelected(this.selectedPaymentMethods)
      ? this.selectedPaymentMethods
      : "All";
    this.getStatDataForExpense(this.academicId);
    this.getReportData(this.academicId, 1);
  }


  updateTypeSelectionLabel() {
    this.onPayeeTypeChange(this.selectedPayeeType);
    this.updatePayeeNameSelection(this.payeeType, this.payeeName)
    const selectedCount = this.payeeType.filter(pt => pt.isSelected).length;

    if (selectedCount === this.payeeType.length) {
      this.customSelectionLabelForPayeeName = 'All';
    } else if (selectedCount === 0) {
      this.customSelectionLabelForPayeeName = 'None';
    } else {
      this.customSelectionLabelForPayeeName = `${selectedCount} ${this.string.selected}`;
    }
    this.updatePayeeTypeLabel();
    this.updatePayeeNameLabel();

  }

  onPayeeTypeChange(selected: any[]) {
    this.payeeType.forEach(type => {
      type.isSelected = selected.some(sel => sel.payeeType === type.payeeType);
    });

    this.payeeType.forEach(type => {
      if (!type.isSelected) {
        this.payeeName.forEach(name => {
          if (name.payeeType === type.payeeType) {
            name.isSelected = false;
          }
        });
      }
    });
    this.selectedPayeeType = this.payeeType.filter(item => item.isSelected);
  }

  onPayeeNameChange(selected: any[]) {
    this.payeeName.forEach(name => {
      name.isSelected = selected.some(sel => sel.payeeId === name.payeeId);
    });
    this.payeeType.forEach(type => {
      const relatedNames = this.payeeName.filter(name => name.payeeType === type.payeeType);

      if (relatedNames.length > 0) {
        type.isSelected = relatedNames.every(name => name.isSelected);
      } else {
        type.isSelected = false;
      }
    });
    this.selectedPayeeType = this.payeeType.filter(type => type.isSelected);
  }

  updateSelectionPayeeNameLabel() {
    this.onPayeeNameChange(this.selectedPayeeName);
    this.updatePayeeTypeSelection(this.payeeType, this.payeeName)
    const selectedCount = this.payeeName.filter(pt => pt.isSelected).length;

    if (selectedCount === this.payeeName.length) {
      this.customSelectionLabelForPayeeName = 'All';
    } else if (selectedCount === 0) {
      this.customSelectionLabelForPayeeName = 'None';
    } else {
      this.customSelectionLabelForPayeeName = `${selectedCount} ${this.string.selected}`;
    }
    this.updatePayeeTypeLabel();
    this.updatePayeeNameLabel();
  }


  // function for update payment method  label
  updateSelectionPaymentMethodLabel() {
    if (!this.selectedPaymentMethods || this.selectedPaymentMethods.length === 0) {
      this.customSelectionLabelForPaymentMethodName = 'None';
    } else if (this.selectedPaymentMethods.length === this.paymentMethods.length) {
      this.customSelectionLabelForPaymentMethodName = 'All';
    } else {
      this.customSelectionLabelForPaymentMethodName = `${this.selectedPaymentMethods.length} ${this.string.selected}`;
    }
  }

  // function for update payee name selection
  updatePayeeNameSelection(payeeType, payeeName) {
    payeeType.forEach(type => {
      payeeName.forEach(name => {
        if (name.payeeType === type.payeeType) {
          name.isSelected = type.isSelected;
        }
      });
    });
    this.selectedPayeeName = this.payeeName.filter(item => item.isSelected);
  }

  // function for update payee type selection
  updatePayeeTypeSelection(payeeType, payeeName) {
    payeeType.forEach(type => {
      const matchingNames = payeeName.filter(name => name.payeeType === type.payeeType);
      if (matchingNames.length > 0) {
        type.isSelected = matchingNames.some(name => name.isSelected);
      } else {
        type.isSelected = false;
      }
    });
    this.selectedPayeeType = this.payeeType.filter(item => item.isSelected);
  }

  // function for update payee type label
  updatePayeeTypeLabel() {
    const selectedCount = this.payeeType.filter(pt => pt.isSelected).length;
    if (selectedCount === this.payeeType.length) {
      this.customSelectionLabel = 'All';
    } else if (selectedCount === 0) {
      this.customSelectionLabel = 'None';
    } else {
      this.customSelectionLabel = `${selectedCount} ${this.string.selected}`;
    }
  }
  // function for update payee label
  updatePayeeNameLabel() {
    const selectedCount = this.payeeName.filter(pn => pn.isSelected).length;
    if (selectedCount === this.payeeName.length) {
      this.customSelectionLabelForPayeeName = 'All';
    } else if (selectedCount === 0) {
      this.customSelectionLabelForPayeeName = 'None';
    } else {
      this.customSelectionLabelForPayeeName = `${selectedCount} ${this.string.selected}`;
    }
  }

  // function for check all isSelected all true or not
  isAllSelected(array: any[]): boolean {
    return array.every(item => item.isSelected === true);
  }

  // function for check all isSelected all false or not
  isAllFalse(array: any[]): boolean {
    return array.every(item => item.isSelected === false);
  }


  // function for call api on page number change
  onPageChange(event: any) {
    const pageNumber = event.page + 1;
    this.getReportData(this.academicId, pageNumber)
  }

  // function for change page limit
  changePageLimit() {
    this.getReportData(this.academicId, 1);
    this.getStatDataForExpense(this.academicId)
  }

  // function for generate dummy array for skelton loader
  generateDummyArray(count: number): any[] {
    return Array.from({ length: count }, () => ({}));
  }

  // function for export open pop up
  showDialog() {
    this.openExportPopUp = true;
  }

  // function for format number
  formatNumber(number) {
    if (number > 0) {
      return number.toLocaleString();
    } else {
      return number;
    }
  }

  // generate number to words
  generateText(num) {
    return this.toWords.convert(num, { currency: true, ignoreDecimal: true });
  }

  // api call for expense report export
  async exportExpenseReportData() {
    try {
      this.sendingReport = true;
      const columnId = this.expenseColumnData.filter(col => col.isDefault === 1).map(col => col.pkReportColumnMapDetailId);
      const body = {
        lang: "en",
        academicId: this.academicId,
        payeeNameId:
          this.appliedPayeeName !== "All"
            ? (
              this.appliedPayeeName.length === 0
                ? []
                : (this.payeeName.length === this.appliedPayeeName.length
                  ? "All"
                  : this.formatPayeeName(this.appliedPayeeName)
                )
            )
            : "All", paymentMethodId:
          this.appliedPaymentMethod !== "All"
            ? (
              this.appliedPaymentMethod.length === 0
                ? []
                : (this.paymentMethods.length === this.appliedPaymentMethod.length
                  ? "All"
                  : this.formatPaymentMethod(this.appliedPaymentMethod)
                )
            )
            : "All",
        startDate: this.startDate,
        endDate: this.endDate,
        selectedColumns: columnId,
        emailIdList: this.generateArrayForEmail(this.emailIds)
      }

      const response: any = await firstValueFrom(this.expenseService.exportReportData(body))
      if (response.status && response.body) {
        customToastr(
          response.body.message
            ? response.body.message
            : "Expense report sent successfully",
          "success"
        );
        this.openExportPopUp = false;
      }
      this.sendingReport = false;
      this.emailIds = '';
    }
    catch (error) {
      this.sendingReport = false;
      customToastr(
        error.error.message
          ? error.error.message
          : "Something went wrong",
        "error"
      )
    }
  }

  // function to generate array for email
  generateArrayForEmail(email: string): string[] {
    if (!email || !email.trim()) return [];
    return email
      .split(',')
      .map(e => e.trim())
      .filter(e => e !== '');
  }

  // function for reset filter
  resetFilter() {
    this.payeeType = this.markAllAsSelected(this.payeeType);
    this.payeeName = this.markAllAsSelected(this.payeeName);
    this.paymentMethods = this.markAllAsSelected(this.paymentMethods);
    this.selectedPayeeName = this.payeeName.filter(item => item.isSelected);
    this.selectedPayeeType = this.payeeType.filter(item => item.isSelected);
    this.selectedPaymentMethods = this.paymentMethods.filter(item => item.isSelected);
    this.startDate = this.selectedAcademicYear.academicStartDate;
    this.endDate = this.selectedAcademicYear.isCurrentAcademic ? moment(new Date()).format('YYYY-MM-DD') : this.selectedAcademicYear.academicEndDate;
    this.startingPageNumber = 1;
    this.updatePayeeTypeLabel();
    this.updatePayeeNameLabel();
    this.updateSelectionPaymentMethodLabel();
    this.applyResetFilter()
    this.isFilterApplied = false;
  }
}


